module.exports = __webpack_public_path__ + "static/img/4.22e1a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colectivo-de-vida/4.png
// module id = dv+A
// module chunks = 0